import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  // Snackbar,
  // Alert,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
// import useOffer from "@/app/features/tender/components/hook/useTender";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { cn } from "@/lib/utils";
import { GiMedicalDrip } from "react-icons/gi";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { LANG } from "@/types";

// interface Category {
//   id: string;
//   name: string;
//   parentId: string | null;
// }
export interface Category {
  id: string;
  name: string;
  TagName: string;
  parentId: string | null;
  parent: Category | null;
  displayOrder: number;
}
interface CategoriesListProps {
  data: Category[];
  // categoriesId: string[];
  // onUpdateCategories: (updatedCategories: string[]) => void;
}

const primaryColor = "#644980";

const SubCategories = ({
  // setSelectedSubCategories,
  enName,
  arName,
}: {
  // setSelectedSubCategories: React.Dispatch<React.SetStateAction<Category[]>>;
  enName: string;
  arName: string;
}) => {
  const { locale } = useLocale();
  const [open, setOpen] = React.useState(true);
  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <div>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <GiMedicalDrip className="text-3xl" />
        </ListItemIcon>
        <ListItemText
          primary={locale === LANG.AR ? arName : enName}
          sx={{ textAlign: locale == LANG.AR ? "right" : "left" }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <GiMedicalDrip className="text-xl" />
            </ListItemIcon>
            <ListItemText
              primary="فئة فئة الثانية"
              sx={{ textAlign: locale == LANG.AR ? "right" : "left" }}
            />
          </ListItemButton>
        </List>
      </Collapse>
    </div>
  );
};
const CategoriesList: React.FC<CategoriesListProps> = ({ data }) => {
  const { locale } = useLocale();
  const [categories, setCategories] = useState<Category[]>([]);
  // const [selectedSubCategories, setSelectedSubCategories] = useState<
  //   Category[]
  // >([]);

  const { t } = useTranslate(locale);
  // const [allCategories, setAllCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  // const { getcategories } = useOffer();
  // const [selectedCategories, setSelectedCategories] =
  //   useState<string[]>(categoriesId);
  // const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarSeverity, setSnackbarSeverity] = useState<
  //   "success" | "warning"
  // >("success");

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        // const response = await getcategories();
        // if (response) {
        //   setAllCategories(response.data);
        // }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // useEffect(() => {
  //   setSelectedCategories(categoriesId);
  // }, [categoriesId]);
  // const handleCategoryToggle = (categoryId: string, categoryName: string) => {
  //   const isSelected = selectedCategories.includes(categoryId);
  //   const updatedCategories = isSelected
  //     ? selectedCategories.filter((id) => id !== categoryId)
  //     : [...selectedCategories, categoryId];
  //   setSelectedCategories(updatedCategories);
  //   onUpdateCategories(updatedCategories);
  //   setSnackbarMessage(
  //     isSelected
  //       ? `${t("alerts.success.categoryRemoved")}: ${categoryName}`
  //       : `${t("alerts.success.categoryAdded")}: ${categoryName}`
  //   );
  //   setSnackbarSeverity(isSelected ? "warning" : "success");
  //   setSnackbarOpen(true);
  // };

  // const handleCloseSnackbar = () => {
  //   setSnackbarOpen(false);
  // };

  // const renderCategoryChips = (parentId: string | null) => {
  //   const childCategories = allCategories.filter(
  //     (category) => category.parentId === parentId
  //   );

  //   if (childCategories.length === 0) {
  //     return null;
  //   }

  //   return (
  //     <Box
  //       component="ul"
  //       sx={{
  //         listStyleType: "none",
  //         paddingRight: parentId ? "20px" : "0px", // Indent child lists
  //         margin: 0,
  //       }}
  //     >
  //       {childCategories.map((category) => (
  //         <Box component="li" key={category.id} sx={{ marginBottom: 1 }}>
  //           <Chip
  //             label={category.name}
  //             sx={{
  //               backgroundColor: selectedCategories.includes(category.id)
  //                 ? primaryColor
  //                 : "#f5f5f5",
  //               color: selectedCategories.includes(category.id)
  //                 ? "#fff"
  //                 : "#333",
  //               "&:hover": { backgroundColor: primaryColor, color: "#fff" },
  //               fontWeight: selectedCategories.includes(category.id)
  //                 ? "bold"
  //                 : "normal",
  //               marginBottom: "4px",
  //             }}
  //             onClick={() => handleCategoryToggle(category.id, category.name)}
  //             clickable
  //           />
  //         </Box>
  //       ))}
  //     </Box>
  //   );
  // };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
        }}
      >
        <CircularProgress sx={{ color: primaryColor }} />
      </Box>
    );
  }
  return (
    <Box sx={{ padding: 2 }}>
      <div>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: primaryColor, fontWeight: "bold" }}
        >
          {t("categories.select")}
        </Typography>
      </div>
      <div className="bg-white select-none w-full h-36 gap-4 no-scrollbar overflow-x-auto rounded-2xl mt-4 p-4 flex items-center">
        {data.map((item) => (
          <div
            className="flex items-center min-w-32 text-center flex-col"
            onClick={() =>
              setCategories((prev) => {
                if (prev.some((element) => element.id === item.id)) {
                  return prev.filter((i) => i.id !== item.id);
                } else {
                  return [...prev, item];
                }
              })
            }
          >
            <div
              className={cn(
                "rounded-full h-20 w-20 flex items-center justify-center",
                categories.some((i) => i.id === item.id)
                  ? "bg-black text-white"
                  : "border border-gray-300"
              )}
            >
              <GiMedicalDrip className="text-3xl" />
            </div>
            <div>{locale === LANG.AR ? item.name : item.TagName}</div>
          </div>
        ))}
      </div>
      <div className="flex gap-5 mt-12">
        <div className="bg-white w-96 p-6 h-[500px] rounded-2xl">
          <div>sub categories</div>
          <div className="no-scrollbar mt-4 overflow-y-auto h-[450px]">
            {categories.map((item) => (
              <SubCategories
                // setSelectedSubCategories={setSelectedSubCategories}
                key={item.id}
                enName={item.name}
                arName={item.TagName}
              />
            ))}
          </div>
        </div>
        <div className="bg-white p-4 w-full h-[500px] rounded-2xl">
          {/* {selectedSubCategories.map((_) => (
            <div>he</div>
          ))} */}
        </div>
      </div>
      {/* <Paper
        elevation={0}
        sx={{
          padding: 2,
          maxHeight: 800,
          overflowY: "auto",
          borderRadius: 2,
          border: `1px solid ${primaryColor}`,
        }}
      >
        {renderCategoryChips(null)}
      </Paper> */}

      {/* <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar> */}
    </Box>
  );
};

export default CategoriesList;
